/* eslint-disable no-param-reassign */
import React from 'react';
import PropTypes from 'prop-types';
import { userShape } from '../propTypes';

function UserIcon({
  user,
  size = '20px',
  style = {},
  className = '',
  round = false,
}) {
  return (
    <img
      alt={user.name}
      title={user.name}
      style={{
        height: size,
        width: size,
        borderRadius: round ? '100%' : undefined,
        ...style,
      }}
      src={user.picture}
      className={`user-icon ${className}`}
    />
  );
}

UserIcon.propTypes = {
  user: userShape.isRequired,
  size: PropTypes.string,
  style: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  round: PropTypes.bool,
};

UserIcon.defaultProps = {
  size: '20px',
  style: {},
  className: '',
  round: false,
};

export default UserIcon;
